import { type LabelType } from '@/defs/misc'

import { type IconType } from './icon'

export const STATS = [
  'colorId',
  'deckFraction',
  'deckTotal',
  'deckTotalCommander',
  'deckTotalFull',
  'inclusionAdded',
  'inclusionCut',
  'inclusionGraphic',
  'inclusion',
  'lift',
  'rank',
  'released',
  'salt',
  'spoiled',
  'synergy',
  'zScore',
] as const
export type StatType = (typeof STATS)[number]
type StatLabelType = LabelType<StatType, { icon: IconType; label: string }>
export const STAT_LABELS: StatLabelType = {
  colorId: { icon: 'mtg-wubrg', label: 'Color ID' },
  deckFraction: { icon: 'layerGroup', label: 'Decks' },
  deckTotal: { icon: 'layerGroup', label: 'Decks' },
  deckTotalCommander: { icon: 'layerGroup', label: 'Decks' },
  deckTotalFull: { icon: 'layerGroup', label: 'Decks' },
  inclusion: { icon: 'percent', label: 'Inclusion' },
  inclusionAdded: { icon: 'percent', label: 'Inclusion' },
  inclusionCut: { icon: 'percent', label: 'Inclusion' },
  inclusionGraphic: { icon: 'percent', label: 'Inclusion' },
  lift: { icon: 'anglesUp', label: 'Lift' },
  rank: { icon: 'chessKing', label: 'Rank' },
  released: { icon: 'calendar', label: 'Release Date' },
  salt: { icon: 'salt', label: 'Salt' },
  spoiled: { icon: 'calendar', label: 'Spoil Date' },
  synergy: { icon: 'wandMagicSparkles', label: 'Synergy' },
  zScore: { icon: 'fire', label: 'Fire Score' },
}

export const STAT_COMBOS = ['requirements', 'colorId', 'inclusion', 'results', 'brackets', 'rank', 'deckTotal'] as const
export type StatComboType = (typeof STAT_COMBOS)[number]
type StatComboLabelType = LabelType<StatComboType, { icon: IconType; label: string }>
export const STAT_COMBO_LABELS: StatComboLabelType = {
  brackets: { icon: 'bracketsCurly', label: 'Brackets' },
  colorId: { icon: 'mtg-wubrg', label: 'ColorID' },
  deckTotal: { icon: 'layerGroup', label: 'Decks' },
  inclusion: { icon: 'percent', label: 'Inclusion' },
  rank: { icon: 'chessKing', label: 'Rank' },
  requirements: { icon: 'list', label: 'Requirements' },
  results: { icon: 'infinity', label: 'Results' },
}
